import primaryButton from '../../../../primary-button';

const light = (params) => primaryButton.brandedSolid.background.disabled.light(params);

export default light;
